// Destino de las peticiones de Fexería. Cada empresa vive en un host (pbxServer): un admin SipMóvil
// habla con el host de la empresa que opera; los demás roles, con el suyo. Módulo puro (probado en
// tests/unit). El token NUNCA se envía a un host que no pase `isValidPbxServer`.

// Solo nombres de host de la plataforma: sin esquema, puerto, ruta ni espacios.
const HOST_RE = /^[a-z0-9-]+(\.[a-z0-9-]+)*\.fexe\.co$/i;

export const BASE_PATH = 'api/fexeria';
export const WS_PATH = 'ws/fexeria/';

export const isValidPbxServer = (host) => typeof host === 'string' && host.length <= 253 && HOST_RE.test(host);

export class HostError extends Error {
  constructor(message, host) {
    super(message);
    this.name = 'HostError';
    this.hostError = true;
    this.host = host;
  }
}

export const INVALID_HOST_MESSAGE = 'Servidor de la empresa no válido';
export const unreachableMessage = (host) => `No se pudo conectar con el servidor de la empresa (${host})`;

const sameHost = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();

// `hostMap` es solo para desarrollo/test (simular otros hosts). Lanza HostError si el pbxServer no es válido.
export function resolveTarget({ isSuper, company, currentHost, hostMap = {} }) {
  const here = { host: currentHost, origin: `https://${currentHost}`, remote: false };
  if (!isSuper || !company) return here;

  const pbx = company.pbxServer;
  if (pbx === undefined || pbx === null || pbx === '') {
    return { ...here, reason: 'pbxServer vacío: se usa el host actual' };
  }
  if (!isValidPbxServer(pbx)) throw new HostError(INVALID_HOST_MESSAGE, pbx);
  if (sameHost(pbx, currentHost)) return here;

  const mapped = hostMap && hostMap[pbx];
  return { host: pbx, origin: mapped || `https://${pbx}`, remote: true };
}

export function fexeriaBaseUrl(opts) {
  return `${resolveTarget(opts).origin}/${BASE_PATH}`;
}

export function fexeriaWsUrl(opts) {
  const { origin } = resolveTarget(opts);
  const host = origin.replace(/^https?:\/\//i, '');
  return `wss://${host}/${WS_PATH}`;
}
